module.exports = __webpack_public_path__ + "static/media/tarjeta-wb-azul-sola.d900254b.png";